module.exports = __webpack_public_path__ + "img/broom_hockey.d65a3073.jpg";